import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import { Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import PickUpPointsDetails from './components/PickUpPointsDetails';
import PickUpPointsDetailsModal from '../AddOrUpdate/components/HubPickUpPointsDetailsModal';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const PickUpPointsDetailsIndex = () => {
  useEffect(() => {
    getPickUpPointDetails();
  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getPickUpPointDetails = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllHubPickUpPointsDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });

      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);

      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );

      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 65,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      // {
      //   Header: 'Emirate',
      //   accessor: 'emirates',
      //   disableGlobalFilter: false,
      // },
      {
        Header: 'Location Name',
        accessor: 'pickUpPointName',
        disableGlobalFilter: false,
      },
      {
        Header: ' Location Code',
        accessor: 'pickupPointCode',
        disableGlobalFilter: false,
      },
      {
        Header: 'Contact Name',
        accessor: 'pickUpPointContactName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Contact Mobile Number',
        accessor: 'pickupPointContactMobileNo',
        disableGlobalFilter: false,
      },
      {
        Header: 'Address',
        accessor: 'pickUpPointAddress',
        disableGlobalFilter: false,
      },

      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: row => (
          <div className="icon-style" >
            <Tooltip title="Click here to edit Territory Details">
              <EditIcon style={{ cursor: "pointer" }} onClick={() => edit(row.row.original)} />
            </Tooltip>
          </div>
        ),
      },
    ],
    [],
  );

  const edit = async (event) => {
    if (event && event?.pickUpPointId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Pick Up Point Details")
    }
  }



  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <PickUpPointsDetails reactTableData={reactTableData} address={temp?.address} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <PickUpPointsDetails isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}

      {viewDetailPopup &&
        <PickUpPointsDetailsModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          dataInfo={temp}
          isTitle={isTitle}
        />}
    </Container>
  );
};

export default PickUpPointsDetailsIndex;